<template>
  <BlocoFormularioCadastro voltar="/convenio" @salvar="salvar()">
    <template #form>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.geral.$error,
          'panel-danger': v$.$validationGroups.geral.$error,
        }"
        class="panel"
      >
        <div id="info_gerais" class="panel-heading">
          <h4 class="panel-title">
            Geral
            <span class="pull-right">{{ resumoGeral }}</span>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <div
                :class="{ 'has-error': v$.convenio.nome.$error }"
                class="form-group"
              >
                <input
                  id="_id"
                  v-model="convenio._id"
                  data-test-id="input-_id"
                  type="hidden"
                  name="_id"
                  class="form-control"
                />
                <label for="nome">Nome <sup>(1)</sup></label>
                <input
                  id="nome"
                  v-model="convenio.nome"
                  data-test-id="input-nome"
                  type="text"
                  class="form-control"
                  name="nome"
                  placeholder="Nome do Convênio"
                  @input="v$.convenio.nome.$touch()"
                />
                <span v-if="v$.convenio.nome.$dirty">
                  <span v-if="!v$.convenio.nome.required" class="help-block">
                    Campo é obrigatório.
                  </span>
                  <span v-if="!v$.convenio.nome.minLength" class="help-block">
                    Campo deve ter pelo menos
                    {{ v$.convenio.nome.$params.minLength.min }} letras.
                  </span>
                  <span v-if="!v$.convenio.nome.maxLength" class="help-block">
                    Campo deve ter no máximo
                    {{ v$.convenio.nome.$params.maxLength.max }} letras.
                  </span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <div class="form-group">
                <label>Situação</label>
                <select
                  id="ativo"
                  v-model="convenio.ativo"
                  data-test-id="select-ativo"
                  name="ativo"
                  class="form-control"
                >
                  <option :value="true">Ativo</option>
                  <option :value="false">Cancelado</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <div class="form-group">
                <label>CNPJ</label>
                <input
                  id="cnpj"
                  v-model="convenio.cnpj"
                  v-mask="'99.999.999/9999-99'"
                  data-test-id="input-cnpj"
                  type="text"
                  class="form-control"
                  name="cnpj"
                  placeholder="CNPJ do Convênio"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <div class="form-group">
                <label>Código ANS</label>
                <input
                  id="ans"
                  v-model="convenio.ans"
                  v-mask="'999999'"
                  data-test-id="input-ans"
                  type="text"
                  class="form-control"
                  name="ans"
                  placeholder="Código de registro ANS do Convênio"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <div class="form-group">
                <label>Particular</label>
                <select
                  id="particular"
                  v-model="convenio.particular"
                  data-test-id="select-particular"
                  name="particular"
                  class="form-control"
                >
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <div class="form-group">
                <label>Valor CH (R$)</label>
                <input
                  id="valorCH"
                  v-model="convenio.valorCH"
                  v-mask="'money'"
                  data-test-id="input-valorch"
                  type="text"
                  class="form-control"
                  name="valorCH"
                  placeholder="Valor CH multiplicador do Convênio"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <div class="form-group">
                <label>Vencimento da Guia (dias)</label>
                <input
                  id="vencimentoGuiaDias"
                  v-model="convenio.vencimentoGuiaDias"
                  v-mask="'999'"
                  data-test-id="input-vencimentoguiadias"
                  type="number"
                  class="form-control"
                  name="vencimentoGuiaDias"
                  placeholder="Dias para o vencimento da guia"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.tabelas.$error,
          'panel-danger': v$.$validationGroups.tabelas.$error,
        }"
        class="panel"
      >
        <div id="info_tabelas" class="panel-heading">
          <h4 class="panel-title"> Tabelas </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div
                :class="{ 'has-error': v$.$validationGroups.tabelas.$error }"
                class="form-group"
              >
                <label for="tabela"
                  >Tabelas de Procedimento
                  <sup>(1)</sup>
                </label>
                <select
                  id="tabelas"
                  v-model="convenio.tabelas"
                  data-test-id="select-tabelas"
                  name="tabelas"
                  class="form-control"
                  multiple
                >
                  <option
                    v-for="tabela in tabelas_procedimentos"
                    :key="tabela.nome"
                    :value="tabela"
                  >
                    {{ tabela.nome }}
                  </option>
                </select>
                <span v-if="v$.convenio.tabelas.$dirty">
                  <span v-if="!v$.convenio.tabelas.required" class="help-block">
                    Campo é obrigatório, você pode informar uma ou mais tabelas.
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>(1) Campos obrigatórios.</p>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, minLength, required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import numeral from 'numeral'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import router from '@/router'
import ConvenioServico from '@/servicos/ConvenioServico'
import MensagemServico from '@/servicos/MensagemServico'
import TabelaServico from '@/servicos/TabelaServico'

const tabelaServico = new TabelaServico()
const convenioServico = new ConvenioServico()
const mensagemServico = new MensagemServico()

export default {
  name: 'ConvenioCadastro',
  directives: { mask: AwesomeMask },
  components: { BlocoFormularioCadastro },

  setup() {
    useMenu(14)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      tabelas_procedimentos: [],
      convenio: {
        nome: '',
        cnpj: '',
        ans: '',
        particular: false,
        ativo: true,
        tabelas: [],
        vencimentoGuiaDias: '',
      },
    }
  },
  validations: {
    convenio: {
      nome: { required, minLength: minLength(5), maxLength: maxLength(60) },
      tabelas: { required },
    },
    $validationGroups: {
      geral: ['convenio.nome'],
      tabelas: ['convenio.tabelas'],
    },
  },
  computed: {
    resumoGeral() {
      return `${this.convenio.nome}`
    },
  },
  created() {
    this.recuperarConvenio()
    this.recuperarTabelas()
  },
  methods: {
    recuperarTabelas() {
      tabelaServico.recuperarTodos({ ativo: true }).then((result) => {
        this.tabelas_procedimentos = result.tabelas
      })
    },
    recuperarConvenio() {
      const convenioId = this.$route.params.id

      if (convenioId) {
        convenioServico.recuperar(convenioId).then((result) => {
          this.convenio = { ...result.convenio }
          this.convenio.valorCH = numeral(result.convenio.valorCH).format(
            '0,0.00'
          )

          const tabelas = result.convenio.tabelas
          tabelas.forEach((t) => {
            tabelaServico.recuperar(t._id).then((res) => {
              this.convenio.tabelas.push(res.tabela)
            })
          })
        })
      }
    },
    salvar() {
      this.v$.$touch()
      if (this.v$.convenio.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        this.convenio.tabelas.forEach((t) => {
          delete t.ativo
          delete t.procedimentos
        })

        const ch = this.convenio.valorCH
        this.convenio.valorCH = numeral(ch).value()

        if (this.convenio._id) {
          convenioServico
            .atualizar(this.convenio._id, this.convenio)
            .then((result) => {
              if (result.erro) {
                mensagemServico.alerta(result.erro.content, result.erro.title)
                return
              }

              router.replace({ name: 'Convenio' })
            })
        } else {
          convenioServico.criar(this.convenio).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Convenio' })
          })
        }
      }
    },
  },
}
</script>
